import qrCode from "../../assets/signinwelcome-qr.png";
import phonesImage from "../../assets/signinwelcome-phones.png";
import appleBadge from "../../assets/applestoreImageBtn.png";
import googleBadge from "../../assets/signinwelcome-googleplay.png";
import { Typography } from "antd";
import WPLayout from "../../components/WPLayout/WPLayout";
import "./signinwelcome.css";

const APP_STORE_LINK =
  "https://apps.apple.com/pk/app/docupdate/id6478404244";
const PLAY_STORE_LINK =
  "https://play.google.com/store/apps/details?id=com.impericus.prescriber&hl=en_US";

const STEPS = [
  {
    title: "Download the DocUpdate app.",
    detail: "Scan the QR code.",
  },
  {
    title: "Sign in using the email and password you just created.",
    detail: "Your email address is your username.",
  },
  {
    title: "Get started with DocUpdate.",
    detail:
      "Explore the tools and resources available in the app, and keep an eye out for future opportunities that may be relevant to your specialty and experience.",
  },
];

const SignInWelcome = () => {
  return (
    <WPLayout>
      <div className="tyv2 w-full flex flex-col items-center">
        <div className="tyv2-surface w-full flex flex-col items-center">
          {/* ===== Hero: phones + welcome copy (no dot texture) ===== */}
          <div className="tyv2-hero w-full px-5 sm:px-0">
            <div className="tyv2-copy-col">
              <Typography.Text className="tyv2-h1 block font-playfair font-semibold">
                Welcome to the DocUpdate Community!
              </Typography.Text>
              <Typography.Paragraph className="tyv2-lead">
                You&rsquo;re all set.
              </Typography.Paragraph>
              <Typography.Paragraph className="tyv2-lead">
                We&rsquo;ll keep you informed about relevant opportunities
                based on your specialty and experience, including surveys,
                advisory programs, product feedback initiatives, educational
                content, and community events. Some opportunities may include
                compensation.
              </Typography.Paragraph>
            </div>

            <div className="tyv2-phones-col">
              <img
                src={phonesImage}
                alt="DocUpdate app listing and getting started screen"
                className="tyv2-phones-img"
              />
              <div className="tyv2-badges">
                <a
                  href={APP_STORE_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Download on the App Store"
                >
                  <img src={appleBadge} alt="Download on the App Store" />
                </a>
                <a
                  href={PLAY_STORE_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Get it on Google Play"
                >
                  <img src={googleBadge} alt="Get it on Google Play" />
                </a>
              </div>
            </div>
          </div>

          {/* ===== Dotted zone: instructions card ===== */}
          <div className="tyv2-dotted w-full flex flex-col items-center px-5 sm:px-8">
            <div className="tyv2-card w-full">
              <Typography.Text className="tyv2-card-title block font-playfair text-center">
                The DocUpdate app gives you access to{" "}
                <em className="tyv2-free">free</em> clinical tools &amp;
                treatment resources designed to accelerate access to care.
              </Typography.Text>

              <div className="tyv2-divider" />

              <div className="tyv2-steps-row">
                <div className="tyv2-qr flex">
                  <img
                    src={qrCode}
                    alt="QR code to download the DocUpdate app"
                  />
                </div>
                <ol className="tyv2-steps">
                  {STEPS.map((step, index) => (
                    <li key={step.title} className="tyv2-step">
                      <span className="tyv2-step-num font-playfair">
                        {index + 1}.
                      </span>
                      <span className="tyv2-step-body">
                        <Typography.Text className="tyv2-step-title block">
                          {step.title}
                        </Typography.Text>
                        <Typography.Text className="tyv2-step-detail block">
                          {step.detail}
                        </Typography.Text>
                      </span>
                    </li>
                  ))}
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </WPLayout>
  );
};

export default SignInWelcome;